"use client";

import { useNotificationItem } from "../../list/item/use-notification-item";
import {
  NotificationToastItemLayout,
  type NotificationToastItemProps,
} from "./layout";

export function DefaultNotificationToastItem({
  notification,
  toastId,
  onDismiss,
}: NotificationToastItemProps) {
  const item = useNotificationItem(notification);

  function handleActivate() {
    item.handleActivate();
    onDismiss(toastId);
  }

  return (
    <NotificationToastItemLayout.Root>
      <NotificationToastItemLayout.Header
        iconName="IconBell2"
        iconStyle="bg-contrast/15 text-heading"
        toastId={toastId}
        onDismiss={onDismiss}
      />
      <NotificationToastItemLayout.Container
        hasTargetUrl={Boolean(item.actionUrl)}
        isUnread={item.isUnread}
        onActivate={handleActivate}
        onMarkRead={item.handleMarkRead}
        onMarkUnread={item.handleMarkUnread}
      >
        <NotificationToastItemLayout.Media
          actor={item.actor}
          iconName="IconBell2"
          iconStyle="bg-contrast/15 text-heading"
        />
        <NotificationToastItemLayout.Content>
          <NotificationToastItemLayout.Title isUnread={item.isUnread}>
            {notification.title}
          </NotificationToastItemLayout.Title>
          <NotificationToastItemLayout.Time>
            {item.relativeCreatedAt}
          </NotificationToastItemLayout.Time>
          {item.previewText && (
            <NotificationToastItemLayout.Body>
              {item.previewText}
            </NotificationToastItemLayout.Body>
          )}
        </NotificationToastItemLayout.Content>
      </NotificationToastItemLayout.Container>
    </NotificationToastItemLayout.Root>
  );
}
